import { ChainablePropType } from './createChainablePropType';
import { IndexableObject } from '../types/ObjectTypes';
import devLogger from 'react-utils/devLogger';
import { Metrics } from '../Metrics';

export type DeprecatedMessageGenerator = (
  propName: string,
  propValue: any,
  props: IndexableObject
) => Parameters<typeof devLogger.warn>[0];
export type DeprecatedMessage = string | DeprecatedMessageGenerator;

function deprecated(
  propType: ChainablePropType,
  message: DeprecatedMessage,
  defaultValue: any
): ChainablePropType {
  const deprecatedPropType: ChainablePropType = (
    props: IndexableObject,
    propName: string,
    componentName: string,
    location: string,
    ...rest: any[]
  ) => {
    const propValue = props[propName];
    const output =
      typeof message === 'function'
        ? message(propName, propValue, props)
        : message;

    if (output && propValue !== defaultValue) {
      Metrics.counter('deprecated-prop-used', {
        component_name: componentName,
      }).increment();

      if (typeof output === 'string') {
        devLogger.warn({ message: output, key: null });
      } else {
        devLogger.warn(output);
      }
    }

    return propType(props, propName, componentName, location, ...rest);
  };

  if (propType.__INTROSPECTION__) {
    deprecatedPropType.__INTROSPECTION__ = {
      ...propType.__INTROSPECTION__,
      deprecated: true,
    };
  }

  return deprecatedPropType;
}

export default deprecated;
